import "core-js/modules/es.number.constructor.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, generatePath, useParams } from 'react-router-dom';
import { getCanMembersContribute, getIsPlaylistEditable } from 'utils/privileges';
import config from 'utils/config';
import Box from 'components/Box';
import Flex from 'components/Flex';
import Divider from 'components/Divider';
import EmptyStateController from 'components/EmptyStateController';
import Landmark from 'components/Landmark';
import Button from 'components/Button';
import { DEFAULT_EDIT_PLAYLIST_ROUTES } from 'screens/SinglePlaylistManager';
import ContentItemList from '../../shared/contentItemList';
import AddContentMenu from './Actions/AddContentMenu';
import ReorderContentButton from './Actions/ReorderContentButton';
import isMultiDomain from 'utils/isMultiDomain';
function ActionBarWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !config.enableComments && /*#__PURE__*/React.createElement(Divider, {
    my: "s",
    mb: "m"
  }), /*#__PURE__*/React.createElement(Flex, {
    mb: "s",
    mx: "-xs",
    mt: "-xs"
  }, children));
}
function PlaylistContent(_ref2) {
  var playlist = _ref2.playlist,
    isError = _ref2.isError;
  var params = useParams();
  var playlistId = Number(params.id);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var contentItems = playlist.content;
  var isDistributed = isMultiDomain(playlist);
  var emptyContent = /*#__PURE__*/React.createElement(Landmark, {
    height: 250,
    title: t('empty_playlist'),
    icon: "playlist"
  }, config.playlistSections && !isDistributed && /*#__PURE__*/React.createElement(Button, {
    mt: "s",
    variant: "shaded",
    as: Link,
    to: generatePath(DEFAULT_EDIT_PLAYLIST_ROUTES.singlePlaylistContent, {
      playlistId: playlist.id
    })
  }, t('actions_add_content')));
  var errorContent = /*#__PURE__*/React.createElement(Landmark, {
    height: 250,
    icon: "playlist"
  }, /*#__PURE__*/React.createElement("strong", null, t('error_404')));
  var canUserEditPlaylist = getIsPlaylistEditable({
    playlist: playlist
  }) || getCanMembersContribute(playlist);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !config.playlistSections && canUserEditPlaylist && /*#__PURE__*/React.createElement(ActionBarWrapper, null, /*#__PURE__*/React.createElement(AddContentMenu, {
    playlist: playlist
  }), /*#__PURE__*/React.createElement(Box, {
    ml: "auto"
  }, /*#__PURE__*/React.createElement(ReorderContentButton, {
    contentItems: contentItems,
    playlistId: playlistId
  }))), /*#__PURE__*/React.createElement(EmptyStateController, {
    isEmpty: !contentItems || contentItems.length === 0,
    emptyContent: emptyContent,
    isError: isError,
    errorContent: errorContent
  }, !isError && /*#__PURE__*/React.createElement(ContentItemList, {
    playlist: playlist
  })));
}
export default PlaylistContent;